module.exports = __webpack_public_path__ + "img/r-200.054264da.jpg";